import { render, staticRenderFns } from "./HxTrip.vue?vue&type=template&id=562fbf3c&scoped=true&"
import script from "./HxTrip.vue?vue&type=script&lang=js&"
export * from "./HxTrip.vue?vue&type=script&lang=js&"
import style0 from "./HxTrip.vue?vue&type=style&index=0&id=562fbf3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562fbf3c",
  null
  
)

export default component.exports